module.exports = __webpack_public_path__ + "/images/ico-max-gift.691fe48.svg";